/* __next_internal_client_entry_do_not_use__ loggingDataState auto */import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import handler from "./handler";
import { localAESStorage } from "@/util/storage";
const refreshOrigin = localAESStorage.getItem("origin") || "collection";
const userLocation = localAESStorage.getItem("userLocation") || "none";
const rankLocation = localAESStorage.getItem("rankLocation") || "none";
const initialDataWareHouse = {
  location: "none",
  generateid: "none",
  origin: refreshOrigin,
  tab: "collection",
  rankLocation: rankLocation,
  userLocation: userLocation
};
export const loggingDataState = create(immer(set => ({
  dataWareHouse: initialDataWareHouse,
  dispatch: action => {
    const {
      type,
      payload
    } = action;
    set(state => {
      handler[type](state, payload);
    });
  }
})));